import React from 'react';

const FooterDetails = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">STRONG VOLT VPN</h2>
        <p className="footer-copy">&copy; 2024 Dexter Eskalarte. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterDetails;
